import type { TrackingParams } from '../types'

const storageKey = 'aquatic-contractors-attribution'

function compactTracking(values: TrackingParams): TrackingParams {
  return Object.fromEntries(
    Object.entries(values).filter(([, value]) => Boolean(value)),
  )
}

export function getStoredTracking(): TrackingParams {
  if (typeof window === 'undefined') return {}

  try {
    const stored = window.sessionStorage.getItem(storageKey)
    return stored ? (JSON.parse(stored) as TrackingParams) : {}
  } catch {
    return {}
  }
}

export function captureTracking(): TrackingParams {
  if (typeof window === 'undefined') return {}

  const params = new URLSearchParams(window.location.search)
  const captured = compactTracking({
    gclid: params.get('gclid') ?? undefined,
    fbclid: params.get('fbclid') ?? undefined,
    utmSource: params.get('utm_source') ?? undefined,
    utmMedium: params.get('utm_medium') ?? undefined,
    utmCampaign: params.get('utm_campaign') ?? undefined,
    utmContent: params.get('utm_content') ?? undefined,
    utmTerm: params.get('utm_term') ?? undefined,
    referrer: document.referrer || undefined,
    landingPage: window.location.href,
  })
  const merged = { ...getStoredTracking(), ...captured }

  if (Object.keys(merged).length > 0) {
    window.sessionStorage.setItem(storageKey, JSON.stringify(merged))
  }

  return merged
}

export function clearTracking(): void {
  if (typeof window !== 'undefined') window.sessionStorage.removeItem(storageKey)
}

export function trackEvent(name: string, values: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined') return

  const event = {
    event: name,
    form_id: 'aquatic_project_request',
    ...values,
  }

  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push(event)
  window.gtag?.('event', name, event)
}

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
    gtag?: (...args: unknown[]) => void
  }
}
